import React from "react";

/**
 * The properties for {@link Stat}
 */
export type StatProps = {
    /** The label for the stat */
    label: string;

    /** The value to display */
    value: React.ReactNode;

    /** Item to display below the value */
    sub?: React.ReactNode;
};

/**
 * A simple stat
 */
export default function Stat(props: StatProps) {
    return (
        <div className={"flex flex-col"}>
            <span className={"mt-6 text-lg/6 font-medium sm:text-sm/6 dark:text-zinc-300"}>{props.label}</span>
            <span className={"mt-3 text-3xl/8 font-semibold sm:text-2xl/8 dark:text-white"}>{props.value}</span>
            {props.sub && <span className={"mt-3 text-sm/6 sm:text-xs/6 dark:text-zinc-400"}>{props.sub}</span>}
        </div>
    );
}
